import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

export function IcnHome(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="home">
      <path d="M2 8l6-5 6 5" />
      <path d="M3.5 7.5V13h3V10h3v3h3V7.5" />
    </Svg>
  );
}
